export default "__VITE_ASSET__8e01c62e__"